import React from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

export const Text = ({
  as,
  className,
  type,
  children,
  ...props
}) => {
  const AsElement = as ?? 'span';
  return (
    <AsElement
      {...props}
      className={clsx(className, styles.text, styles[type])}
    >
      {children}
    </AsElement>
  );
};
